const UiRoutes = {
  LOGIN: '/login'
};

const contentType = {
  MULTIPART: "multipart",
};

export { UiRoutes, contentType };
